import product from '@/pages/apply/product.vue'

export default [
    {
        path: '/product',
        component: product,
        meta: { title: 'Konfirmasi Pinjaman' }
    }
]